import { useContext } from 'react';
import { Text } from '@shared/components/Text';
import { View } from '@shared/components/View';
import { MBIconV2 } from '@shared/components/image';
import { ColorThemeContext, grid } from '@shared/styles';
import { i18n } from '@shared/util/i18n';
import { Tag } from './tag';
import { MAX_TAG_LENGTH, generateTagColor } from './utils';

interface Props {
  query: string;
  numberOfOptions: number;
}

export function MBCreateTagRow({ query, numberOfOptions }: Props) {
  const colors = useContext(ColorThemeContext);

  return (
    <View row wrap centerVertically>
      <MBIconV2 name="plus" color={colors.foregroundActive} size={grid(4)} />
      <View paddingLeft={2}>
        <Text size="body1">
          {query.length > 0
            ? i18n('card.blocks.tagsInput.createTagLabel')
            : i18n('card.blocks.tagsInput.createNewTagLabel')}
        </Text>
      </View>
      {query.length > 0 && (
        <View paddingLeft={2}>
          <Tag
            color={generateTagColor(numberOfOptions)}
            label={query.slice(0, MAX_TAG_LENGTH)}
            style={{ maxWidth: grid(20) }}
          />
        </View>
      )}
    </View>
  );
}
